import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer } from "redux-persist";
import persistStore from "redux-persist/es/persistStore";
import storage from "redux-persist/lib/storage"; // local storage
import { analyticsMiddleware } from "../middleware.js/analyticsMiddleware";
import { middleware } from "../middleware.js/middleware";
import { appStateReducer } from "./appStateSlice";
import { filtersReducer } from "./filtersSlice";
import { savedParksReducer } from "./savedParksSlice";

const dataPersistConfig = {
  key: "data",
  storage,
  whitelist: ["savedParks"], // only persist savedParks
};

const reducers = combineReducers({
  appState: appStateReducer,
  filters: filtersReducer,
  savedParks: savedParksReducer,
});

const persistedReducer = persistReducer(dataPersistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        warnAfter: 1000,
      },
      immutableCheck: false,
    })
      .concat(middleware)
      .concat(analyticsMiddleware),
});

export const persistor = persistStore(store);
